import {Component, Inject, OnInit} from '@angular/core';
import {LocalStorageService} from './infrastructure/services/local-storage.service';
import {TranslateService} from '@ngx-translate/core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title: 'My NTRA';
  constructor(private lsService: LocalStorageService,
              private translateService: TranslateService,
              @Inject(DOCUMENT) private document: Document) {
    translateService.addLangs(['en', 'ar'])
    translateService.setDefaultLang('en');
    const browserLang = this.translateService.getBrowserLang();
    if (browserLang.match(/en|ar/)) {
      this.lsService.setLang(browserLang);
    } else {
      this.lsService.setLang('en')
    }
  }

  ngOnInit() {

    const headEl = this.document.getElementsByTagName('head')[0];
    const newLinkEl = this.document.createElement('link');
    newLinkEl.href = this.lsService.getLang() + '-layout.css';
    newLinkEl.rel = 'stylesheet';
    newLinkEl.type = 'text/css';
    newLinkEl.id = 'lang-style';
    headEl.appendChild(newLinkEl);
    this.lsService.languageChanged.subscribe(() => {
      this.translateService.use(this.lsService.getLang());
      this.document.getElementById('lang-style').setAttribute('href', this.lsService.getLang() + '-layout.css');
    });
  }

  changeLanguage() {
    this.lsService.changeLang();
  }
}
